import React, { useContext, useState } from 'react'
import { GlobalContext } from '../../context/provider'
import invoice_ledgeraction from '../../context/action/company/invoice_ledgeraction';
import loan_outaction from '../../context/action/company/loan_outaction';
import Company_invoice_ledger_table from './company_invoice_ledger_table';
import Company_loan_out_ledger_table from './company_loan_out_ledger_table';
import ledgeraction from '../../context/action/company/ledgeraction';
import Company_ledger_table from './company_ledger_table';

const Companyledger = () => {
    const {initState, clear} = useContext(GlobalContext);
    
    const [table_type,settable_type]=useState('');
    const [invoice,setinvoice]=useState([]);
    const [loan_out,setloan_out]=useState([]);
    const [ledger,setledger]=useState([]);
    var company_id = initState?.ledger_company_id;
    var company_name = initState?.ledger_company_name;
    
    return (
        <div className="min-h-screen p-4 sm:p-6 lg:p-8 bg-slate-50">
            <div className="w-full h-16 sm:h-20 lg:h-24 flex justify-center items-center text-xl sm:text-2xl md:text-3xl lg:text-4xl mb-4 sm:mb-6">
                 تۆمارەکانی - {company_name} 
            </div>
            <div className="flex flex-col sm:flex-row justify-center gap-4 sm:gap-6 lg:gap-8">
                <div className="flex justify-center items-center cursor-pointer w-full sm:w-1/2 rounded-lg bg-white text-center shadow-[0_2px_15px_-3px_rgba(0,0,0,0.07),0_10px_20px_-2px_rgba(0,0,0,0.04)] hover:shadow-lg transition-shadow duration-300" onClick={()=>{
                    invoice_ledgeraction(company_id)(clear).then((res)=>{
                        setinvoice(res);
                        settable_type('invoice');
                    });
                }}>
                    <h5 className="py-6 sm:py-8 lg:py-10 px-4 text-2xl sm:text-3xl lg:text-4xl font-medium leading-tight text-neutral-800">
                        وەسڵی کڕدراو
                    </h5>
                    {/* <div className="border-t-2 border-neutral-100 px-6 py-3">
                    {" "}
                    لە بەرواری , بۆ بەرواری , باڕکۆد
                    </div> */}
                </div>
                <div className="flex justify-center items-center cursor-pointer w-full sm:w-1/2 rounded-lg bg-white text-center shadow-[0_2px_15px_-3px_rgba(0,0,0,0.07),0_10px_20px_-2px_rgba(0,0,0,0.04)] hover:shadow-lg transition-shadow duration-300" onClick={()=>{
                    loan_outaction(company_id)(clear).then((res)=>{
                        setloan_out(res);
                        settable_type('loan_out');
                    });   
                }}>
                    <h5 className="py-6 sm:py-8 lg:py-10 px-4 text-2xl sm:text-3xl lg:text-4xl font-medium leading-tight text-neutral-800">
                        قەرزی دراوە
                    </h5>
                    {/* <div className="border-t-2 border-neutral-100 px-6 py-3">
                    {" "}
                    لە بەرواری , بۆ بەرواری , باڕکۆد
                    </div> */}
                </div>
            </div>
            <div className="mt-10 flex flex-col sm:flex-row justify-center gap-4 sm:gap-6 lg:gap-8">
                <div className="flex justify-center items-center cursor-pointer w-full rounded-lg bg-white text-center shadow-[0_2px_15px_-3px_rgba(0,0,0,0.07),0_10px_20px_-2px_rgba(0,0,0,0.04)] hover:shadow-lg transition-shadow duration-300" onClick={()=>{
                    ledgeraction(company_id)(clear).then((res)=>{
                        setledger(res);
                        settable_type('ledger');
                    });   
                }}>
                    <h5 className="py-6 sm:py-8 lg:py-10 px-4 text-2xl sm:text-3xl lg:text-4xl font-medium leading-tight text-neutral-800">
                        کەشف حساب
                    </h5>
                    {/* <div className="border-t-2 border-neutral-100 px-6 py-3">
                    {" "}
                    لە بەرواری , بۆ بەرواری , باڕکۆد
                    </div> */}
                </div>
            </div>
            <div className="mt-6 sm:mt-8 lg:mt-10">
                {table_type=='invoice'? <Company_invoice_ledger_table invoice={invoice}/>:
                 table_type=='loan_out'?<Company_loan_out_ledger_table loan_out={loan_out}/>:
                 table_type=='ledger'?<Company_ledger_table ledger={ledger} />:
                 null}
            </div>
        </div>
    )
}

export default Companyledger